module.exports = __webpack_public_path__ + "static/media/1.745a64a1.png";